<template>
  <div class="bespread-wrap module-layer1">
    <div class="screen-container">
      <div class="kv-content">
        <img
          src="../../assets/img/layer1/slogan.png"
          alt=""
          srcset=""
          class="kv-slogan"
        />
        <img
          src="../../assets/img/layer1/reg-btn.png"
          alt=""
          srcset=""
          class="reg-btn cursor"
          @click="handleReg()"
        />
      </div>
      <!-- <div class="blog">
        <div class="share-icon" :class="arrowFlag ? 'bgShow' : 'bgHide'">
          <div class="iconarrow" @click="handleIconArrow()"></div>
          <div class="b-icon">
            <img
              v-for="idx in 4"
              :key="idx"
              :src="require('../../assets/img/layer1/c-' + idx + '.png')"
              alt=""
              srcset=""
              @click="handleIcon(idx)"
            />
          </div>
        </div>
        <div class="bui-t"  :class="buiFlag ? 'bgShow' : 'bgHide'">

          <img
            src="../../assets/img/layer1/bui.png"
            alt=""
            srcset=""
            class="bui cursor"
            @click="handleReg()"
          />
          <div class="buiarrow" @click="handleBuiArrow()"></div>

        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  name: "app",

  data() {
    return {
      // arrowFlag: true,
      // buiFlag: true
    };
  },
  watch: {}, 
  created() {},
  methods: {
    // handleIconArrow() {
    //   this.arrowFlag = !this.arrowFlag;
    // },
    // handleBuiArrow() {
    //   this.buiFlag = !this.buiFlag;
    // },
    handleReg() {
      this.$emit("goReg");
    },
    // handleIcon(val) {
    //   if (val == 1) {
    //     alert("等");
    //   } else if (val == 2) {
    //     this.common.goShare("yt");
    //   } else if (val == 3) {
    //     this.common.goShare("fb");
    //   } else if (val == 4) {
    //     this.common.goShare("dc");
    //   }
    // }
  }
};
</script>
<style lang="scss" scoped>
.module-layer1 {
  // pointer-events: none;
  background-image: url("../../assets/img/layer1/bg.png ");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  .screen-container {
    width: calc(100% - 250px);
    .kv-content {
      position: absolute;
      bottom: 0vw;
      left: 50%;
      transform: translate(-50%, 0);
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      z-index: 1;
      gap: 19vw;

      .kv-slogan {
        width: 715px;
        height: auto;
      }
      .reg-btn {
        width: 410px;
        height: auto;
      }
    }
    .blog {
      position: absolute;
      right: 0;
      top: 2vw;
      display: flex;
      align-items: end;
      flex-direction: column;
      gap: 2vw;
      .share-icon {
        background-image: url("../../assets/img/layer1/share-bg.png");
        width: 291px;
        height: 86px;
        position: relative;
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        .iconarrow {
          width: 49px;
          height: 100%;
        }
        .b-icon {
          width: calc(100% - 50px);
          height: 100%;
          position: absolute;
          right: 0;
          display: flex;
          align-items: center;
          gap: 0.5vw;
          img {
            width: 50px;
            height: auto;
          }
        }
      }
      .bui-t {
        width: 339px;
        height: 222px;

        position: relative;
        .buiarrow {
          width:75px;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
        }
        .bui {
          width: 100%;
          height: auto;
        }
      }
    }
    .bgShow {
      transition: all 0.3s;
    }
    .bgHide {
      transition: all 0.3s;
      margin-right: -13.9vw;
    }
  
  }
}
@media screen and (max-width: 1200px) {
  .module-layer1 {
    .kv-content {
      gap: 28vw !important;
      bottom: 4vw !important;
    }
  }
}

@media screen and (min-width: 2000px) and (max-width: 2561px) {
  .module-layer1 {
    .kv-content {
      bottom: 3vw !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/publicComponents/layer1.vue